import { render, staticRenderFns } from "./OwnerManager.vue?vue&type=template&id=20599cb2&scoped=true"
import script from "./OwnerManager.vue?vue&type=script&lang=js"
export * from "./OwnerManager.vue?vue&type=script&lang=js"
import style0 from "./OwnerManager.vue?vue&type=style&index=0&id=20599cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20599cb2",
  null
  
)

export default component.exports